/**
 * @remarks Rewards and points functions
 * */
import { ResponseGetSystemSetting, ResponseGetSystemAnnounce } from "../../@types/fun-to-wait";
import $http from "./http";
import { AxiosResponse, AxiosError } from "axios";

export async function getSystemSetting(domain?: string): Promise<ResponseGetSystemSetting> {
    return await $http
        .get(`/v1/system-setting`, { params: { domain } })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => Promise.reject(error.response));
}

export async function getSystemAnnounces(domain?: string): Promise<ResponseGetSystemAnnounce[]> {
    return await $http
        .get(`/v1/system-announces`, { params: { domain } })
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) => Promise.reject(error.response));
}
